import LoginForm from "../components/LoginForm";

const Login = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-8">
      <LoginForm />
    </div>
  );
};

export default Login;
